import { render, staticRenderFns } from "./pricingInfo.vue?vue&type=template&id=7b346706&scoped=true&"
import script from "./pricingInfo.vue?vue&type=script&lang=js&"
export * from "./pricingInfo.vue?vue&type=script&lang=js&"
import style0 from "./pricingInfo.vue?vue&type=style&index=0&id=7b346706&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b346706",
  null
  
)

export default component.exports